/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import baseRegister from './base-register'

// Array of sections
export default [
  {
    title: '자동매매',
    icon: 'CpuIcon',
    route: 'kiwoom-auto-trade-strategy-compare',
  },
  {
    title: '일자별 테마',
    icon: 'CalendarIcon',
    route: 'kiwoom-theme-daily',
  },
  {
    title: '일자별 테마 분석',
    icon: 'LayersIcon',
    route: 'kiwoom-theme-analysis',
  },
  {
    title: '계좌',
    icon: 'CreditCardIcon',
    route: 'kiwoom-account',
  },
  {
    title: '순위정보',
    icon: 'BarChart2Icon',
    children: [
      {
        title: '거래대금상위요청',
        route: 'kiwoom-trade-amount-top',
      },
    ],
  },
  ...baseRegister,
]
